import React, { Fragment, useState, useEffect, useRef, useContext } from "react";
import styled, { ThemeProvider, ThemeContext } from "styled-components";
import { Panel, Button, useScrollEvent } from "../../index";

import { HamburgerToggleIcon } from "./components/HamburgerToggleIcon";
import { disableBodyScroll, enableBodyScroll } from "body-scroll-lock";
import { MenuLinksMobile } from "./components/MenuLinksMobile";
import { MenuLinksDesktop } from "./components/MenuLinksDesktop";
import { getLogoVariant } from './AnyfinLogo';

export var DesktopMenu = function DesktopMenu(_ref) {
  var startTransparent = _ref.startTransparent,
      menuContent = _ref.menuContent,
      _ref$wrapLink = _ref.wrapLink,
      wrapLink = _ref$wrapLink === undefined ? null : _ref$wrapLink,
      wrapLinkLogo = _ref.wrapLinkLogo,
      currentPathname = _ref.currentPathname,
      logoVariant = _ref.logoVariant,
      pushdownNotification = _ref.pushdownNotification;

  var _useScrollEvent = useScrollEvent({ offset: 20 }),
      navAtTop = _useScrollEvent.toggle;

  var PushdownNotification = pushdownNotification;

  var _useState = useState(false),
      open = _useState[0],
      setOpen = _useState[1];

  var ref = useRef(null);
  var theme = useContext(ThemeContext);

  useEffect(function () {
    if (open) {
      disableBodyScroll(ref.current);
      document.body.classList.add("nprogress_menu");
    } else {
      enableBodyScroll(ref.current);
      document.body.classList.remove("nprogress_menu");
    }
  }, [open]);

  return React.createElement(
    Fragment,
    null,
    React.createElement(PushdownNotification, null),
    React.createElement(
      Background,
      {
        className: navAtTop && "navAtTop",
        startTransparent: startTransparent
      },
      React.createElement(PushdownNotification, null),
      React.createElement(
        PanelStyled,
        { className: navAtTop && "navAtTop" },
        React.createElement(
          LogoImgCont,
          null,
          React.createElement(
            LogoImgInner,
            { className: navAtTop && "navAtTop" },
            wrapLinkLogo(getLogoVariant(logoVariant))
          )
        ),
        React.createElement("div", { style: { flex: 1 } }),
        React.createElement(
          ThemeProvider,
          {
            theme: navAtTop ? {} : {
              primary: theme.colors.coreNavy,
              textNegative: theme.colors.coreWhite,
              textMedium: theme.colors.coreGrey
            }
          },
          React.createElement(
            Fragment,
            null,
            React.createElement(MenuLinksDesktop, {
              wrapLink: wrapLink,
              navAtTop: navAtTop,
              menuContent: menuContent
            }),
            menuContent.mainCtaElementDesktop ? menuContent.mainCtaElementDesktop : React.createElement(
              Button,
              {
                variant: "primary",
                compact: true,
                m: "0"
                // shouldAnimate={ctaToggle && true}
                , onClick: menuContent.mainCtaAction
              },
              React.createElement(
                "span",
                { style: { fontSize: "14px" } },
                menuContent.mainCta
              )
            )
          )
        )
      )
    )
  );
};

var transition = "200ms cubic-bezier(0.14, 0.98, 0.3, 1.11)";
var transOpenMenuTime = "400ms";
var transOpenMenuEasing = "cubic-bezier(0.14, 0.98, 0.3, 1.11)";

var Background = styled.nav.withConfig({
  displayName: "DesktopMenu__Background",
  componentId: "sc-61gw2q-0"
})(["position:fixed;z-index:900;top:0;left:0;right:0;width:100%;background-color:", ";&.navAtTop{background-color:", ";}transition:background-color ", ";will-change:background-color;"], function (props) {
  return props.theme.navBg;
}, function (props) {
  return props.startTransparent ? "inherit" : props.theme.background;
}, transition);

var PanelStyled = styled(Panel).withConfig({
  displayName: "DesktopMenu__PanelStyled",
  componentId: "sc-61gw2q-1"
})(["height:80px;transition:height ", ";&.navAtTop{height:120px;}will-change:height;display:flex;justify-content:space-between;align-items:center;*{box-sizing:border-box;}"], transition);

var LogoImgCont = styled.div.withConfig({
  displayName: "DesktopMenu__LogoImgCont",
  componentId: "sc-61gw2q-2"
})(["height:100%;"]);

var LogoImgInner = styled.div.withConfig({
  displayName: "DesktopMenu__LogoImgInner",
  componentId: "sc-61gw2q-3"
})(["display:block;position:relative;height:100%;padding:0.5rem 0;cursor:pointer;&.navAtTop{padding:1rem 0;}transition:padding ", ";will-change:padding;"], transition);